import React from "react";
import BaseNumberInput from "./baseNumberInput";
import { CurrencyInputProps } from "models/propTypes/wintFormPropsTypes";
import { LocalizationHelperInstance } from "utils/helpers";

const CurrencyInput: React.FC<CurrencyInputProps> = (props) => {
  const currentSuffix = props.currency && LocalizationHelperInstance.getCurrencySymbol(props.currency);
  const currentPrefix = props.isCredit ? "-" : "";

  return (
    <BaseNumberInput
      {...props}
      type="number"
      allowLeadingZeros={false}
      format={undefined}
      maxNumber={undefined}
      fixedDecimalScale
      decimalPoints={props.decimalPoints === undefined ? 2 : props.decimalPoints}
      suffix={currentSuffix}
      prefix={currentPrefix}
      data-testid={`${props.name}CurrencyInput`}
    />
  );
};

export default CurrencyInput;
